<template>
  <div id="extend" class="word-break-keep-all">
    <section id="hero">
      <div class="container">
        <p>프리미엄 보고서</p>
        <h1 class="title">6배 빨리 제작하는 프리미엄 보고서로<br class="hidden-sm">계약률이 높아집니다</h1>
        <button type="button" class="hz-btn-default hz-btn-lg" @click="scrollToTutorial">튜토리얼 보기</button>
      </div>
    </section>
    <section id="search">
      <div class="container">
        <div class="row">
          <div class="col-lg-offset-3 col-lg-6 col-md-offset-2  col-md-8 padding-0">
            <div v-if="!user.id" style="position: absolute; width: 100%; height: 100%; z-index: 5;" @click="showLoginModal"></div>
            <index-input-address ref="inputAddress" v-model="address"></index-input-address>
            <button type="button" v-show="address.length === 0" class="btn-search" @click="search">검색하기</button>
            <button type="button" v-show="address.length > 1" class="btn-search" @click="review">검토하기</button>
            <div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="list" v-if="user.id">
      <div class="container">
        <div class="search-wrap" v-if="user.auth_level === '90'">
          <div class="row">
            <div class="col-sm-4">
              <div class="checkbox">
                <label>
                  <input type="checkbox" v-model="companyAllCheck" @change="retrieveOthers">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  해줌 전체
                </label>
              </div>
            </div>
            <div class="col-sm-8 text-right">
              <input type="text" class="hz-input-default hz-input-md" maxlength="100" placeholder="검색할 프로젝트명을 입력해주세요." v-model="searchText" @keypress.prevent.enter="searchProject">
              <button type="button" class="hz-btn-primary hz-btn-md" @click="searchProject">검색하기</button>
            </div>
          </div>
        </div>
        <kendo-grid ref="grid"
                    :columns="tableFields"
                    :options="tableOptions"
                    :auth="true"
                    :dataUrl="dataUrl"
                    :message="'저장된 보고서가 없습니다.'" :dblClickRow="viewDetail"></kendo-grid>
      </div>
    </section>
    <section id="problem">
      <div class="container">
        <h2 class="title">아직도 고객을 고민하게 만드는<br>보고서를 만들고 있나요?</h2>
        <p class="description">고객이 궁금해하고 고민하는 부분에 따라 보고서도 달라져야 합니다.</p>
        <img src="~@/assets/img/premium/img-premium-problem-01@2x.png">
      </div>
    </section>
    <section id="benefit">
      <div class="container">
        <h2 class="title">고객의 빠른 결정을 돕는<br>맞춤 보고서가 10분 만에!</h2>
        <ul class="row nav nav-tabs">
          <li class="col-xs-3 active">
            <a href="#benefit1" data-toggle="tab">수익비교</a>
          </li>
          <li class="col-xs-3">
            <a href="#benefit2" data-toggle="tab">목차선택</a>
          </li>
          <li class="col-xs-3">
            <a href="#benefit3" data-toggle="tab">자동제작</a>
          </li>
          <li class="col-xs-3">
            <a href="#benefit4" data-toggle="tab">자료첨부</a>
          </li>
        </ul>
        <div class="row">
          <div class="tab-content col-md-offset-1 col-md-10">
            <div id="benefit1" class="tab-pane fade in active">
              <div class="tab-pane-header">
                <p class="description">4가지 조건별 수익비교</p>
              </div>
              <div class="tab-pane-body">
                <video muted loop playsinline>
                  <source :src="profitVideoUrl" type="video/mp4">
                  비디오 재생을 지원하지 않는 브라우저 입니다.
                </video>
              </div>
            </div>
            <div id="benefit2" class="tab-pane fade in">
              <div class="tab-pane-header">
                <p class="description">15가지 목차 중 선택 제작</p>
              </div>
              <div class="tab-pane-body">
                <video muted loop playsinline>
                  <source :src="listVideoUrl" type="video/mp4">
                  비디오 재생을 지원하지 않는 브라우저 입니다.
                </video>
              </div>
            </div>
            <div id="benefit3" class="tab-pane fade in">
              <div class="tab-pane-header">
                <p class="description">10분 내 고품질 보고서 자동 제작</p>
              </div>
              <div class="tab-pane-body">
                <video muted loop playsinline>
                  <source :src="reportVideoUrl" type="video/mp4">
                  비디오 재생을 지원하지 않는 브라우저 입니다.
                </video>
              </div>
            </div>
            <div id="benefit4" class="tab-pane fade in">
              <div class="tab-pane-header">
                <p class="description">배치도, 견적서 등 5가지 첨부 가능</p>
              </div>
              <div class="tab-pane-body">
                <img src="~@/assets/img/premium/img-premium-benefit-file.jpg" class="img-responsive">
              </div>
            </div>
            <img src="~@/assets/img/img-video-border.png" class="video-border">
          </div>
        </div>
      </div>
    </section>
    <!-- 보고서 생성 알림창 -->
    <modal ref="createModal" :id="createModal.id" :type="createModal.type"
           :title="createModal.title" :size="createModal.size" :fields="createModal.fields"
           @submit="$router.push({name: 'extendNew', params: { id: selectReportId, new: true }})"></modal>
    <!-- 보고서 삭제 알림창 -->
    <modal ref="removeModal" :id="removeModal.id" :type="removeModal.type" :title="removeModal.title"
           :size="removeModal.size" :fields="removeModal.fields" @submit="removeReport"></modal>
  </div>
</template>

<script>
  import api from '@/api/index'
  import IndexInputAddress from '@/components/IndexInputAddress'
  import KendoGrid from 'common/components/KendoGrid'
  import Modal from 'common/components/Modal'
  import eventHub from '@/shared/EventHub'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'extend',
    components: { IndexInputAddress, KendoGrid, Modal },
    data: function () {
      return {
        address: '',
        searchText: '',
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/review/exlist/',
        profitVideoUrl: require('../../assets/video/premium/video-premium-benefit-profit.mp4'),
        listVideoUrl: require('../../assets/video/premium/video-premium-benefit-list.mp4'),
        reportVideoUrl: require('../../assets/video/premium/video-premium-benefit-report.mp4'),
        companyAllCheck: false,
        selectReportId: '',
        tableFields: [
          {
            field: 'project_name',
            title: '프로젝트명',
            type: 'string',
            width: '250px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: {multi: true, search: true}
          },
          {
            field: 'reg_date',
            title: '저장일',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'capacity',
            title: '용량(kWp)',
            type: 'number',
            width: '100px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              const capacity = dataItem['extend_profit_condition'].expect_capacity
              return capacity
            }
          },
          {
            field: 'reg_by__first_name',
            title: '회사명',
            type: 'string',
            width: '150px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: {multi: true, search: true}
          },
          {
            field: 'extend_user',
            title: '담당자',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: {multi: true, search: true}
          },
          {
            field: 'extend_grade',
            title: '평가',
            type: 'string',
            width: '80px',
            sortable: false,
            filterable: {multi: true, search: true},
            template: function (dataItem) {
              let template = ''
              const state = dataItem['extend_grade']
              // 단독주택 서비스 일 경우
              if (state === '가능') {
                template = `<div class='state-tag possible-tag'>가능</div>`
              } else if (state === '불가') {
                template = `<div class='state-tag impossible-tag'>불가</div>`
              } else if (state === '보류') {
                template = `<div class='state-tag hold-tag'>보류</div>`
              } else {
                template = `<div class='state-tag'>미정</div>`
              }
              return template
            }
          },
          {
            field: 'oneclick',
            title: '원클릭사업검토',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<i rpid='${dataItem['id']}' type='oneclick'
                        class='glyphicon glyphicon-download-alt' style='cursor: pointer; font-weight: bold;'></i>`
            }
          },
          {
            field: 'extend',
            title: '프리미엄보고서',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              let template = ''
              if (dataItem['extend_status'] === 'U') {
                template = `<i rpid='${dataItem['id']}' type='extend'
                        class='glyphicon glyphicon-download-alt' style='cursor: pointer; font-weight: bold;'></i>`
              } else {
                template = `<i rpid='${dataItem['id']}' type='extend'
                        class='glyphicon glyphicon-pencil' style='cursor: pointer; font-weight: bold;'></i>`
              }
              return template
            }
          },
          {
            field: 'delete',
            title: '삭제',
            type: 'string',
            width: '80px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<div rpid="${dataItem['id']}" regby="${dataItem['reg_by']}" title="${dataItem['project_name']}" class="k-grid-remove" style="cursor: pointer;">☓</div>`
            }
          }
        ],
        tableOptions: {
          parameter: [
            { name: 'all_check', value: 'N' },
            { name: 'project_name', value: '' }
          ],
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 20,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        },
        createModal: {
          id: 'createModal',
          type: 'confirm',
          title: '보고서 생성',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['프리미엄 보고서를 생성하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        removeModal: {
          id: 'removeModal',
          type: 'confirm',
          title: '보고서 삭제',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        isPaidMember: 'isPaidMember'
      })
    },
    watch: {
      'user': {
        handler (val) {
          // 로그인한 유저일 경우, 해당 페이지에 접근 권한을 체크한다.
          if (typeof val.id !== 'undefined') {
            this.$store.dispatch('checkAccessMenu')
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      scrollToTutorial () {
        const position = document.querySelector('#benefit .nav-tabs').offsetTop - 80
        $('html,body').stop().animate({scrollTop: (position)}, 500)
      },
      showLoginModal () {
        // Main.vue로 이벤트 전달
        eventHub.$emit('showLoginModal')
      },
      search () {
        // 입력필드에 입력된 주소지에 상세정보를 검색한다.
        this.$refs.inputAddress.onSearch()
      },
      review () {
        // 유료회원이 아닐 경우, 유료회원 전용 서비스임을 알리는 창을 띄운다.
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return false
        }

        // 검색 된 주소목록이 있을 경우, 파라미터에 주소정보를 담아 원클릭보고서 페이지로 이동.
        const address = this.address
        if (address) {
          this.$router.push({name: 'extendNew', params: { address: address }})
        }
      },
      viewDetail (id, type, preview = false) {
        /**
         * 보고서 상세보기를 실행하는 함수입니다.
         * 두가지 상황에 이벤트가 발생합니다.
         * 1. 보고서 목록에서 row 더블클릭 (Object 형태에 보고서 데이터가 전달됨)
         * 2. 보고서 다운로드 아이콘 클릭 (String 형태에 보고서 유형 플래그가 전달됨)
         * data 파라미터에 타입이 스트링인지 오브젝트인지에 따라 동작을 구분합니다.
         */

        // 다운로드 아이콘 이벤트 일 경우
        if (preview) {
          this.$router.push({name: `${type}Load`, params: {id: id, preview: true}})
          return false
        }

        // 더블클릭 이벤트 일 경우
        const isDblClick = typeof type === 'object'
        if (isDblClick) {
          // 이미 생성된 보고서가 있을 경우엔 페이지 이동
          if (type['extend_status'] === 'U') {
            this.$router.push({name: 'extendLoad', params: {id: id}})
            return false
          }
        }

        // 그 외 신규생성 일 경우, 유료회원인지 확인한다.
        if (this.isPaidMember) {
          this.selectReportId = id
          this.$refs.createModal.show()
        } else {
          eventHub.$emit('showChargeModal')
          return false
        }
      },
      setDownloadEvent () {
        $(document).on('click', '.kendo-grid tbody tr .glyphicon', (e) => {
          const id = e.target.getAttribute('rpid')
          const type = e.target.getAttribute('type')
          const isDownload = e.target.classList.contains('glyphicon-download-alt')

          this.viewDetail(id, type, isDownload)
        })
      },
      setRemoveEvent () {
        $(document).on('click', '.kendo-grid tbody tr .k-grid-remove', (e) => {
          const target = e.target
          const registerUser = parseInt(target.getAttribute('regby'))
          const currentUser = parseInt(this.user.id)

          // 로그인한 사용자가 보고서 작성자와 동일한지 확인
          if (registerUser === currentUser) {
            this.selectReportId = target.getAttribute('rpid')
            this.removeModal.fields[0].message = [target.title + ' 보고서를 삭제하시겠습니까?']
            this.$refs.removeModal.show()
          } else {
            alert('본인이 작성한 보고서가 아닙니다.')
          }
        })
      },
      removeReport () {
        api.removeReport(this.selectReportId, response => {
          if (response.error) {
            this.showToastMessage('보고서 삭제실패')
          } else {
            this.showToastMessage('보고서 삭제완료')
            this.$refs.grid.refresh()
          }
        })
      },
      retrieveOthers () {
        // 보고서 전체보기 클릭 여부에 따라 목록 API Parameter를 설정해준다.
        const isAll = this.companyAllCheck ? 'Y' : 'N'

        this.tableOptions.parameter[0].value = isAll
        this.$refs.grid.refresh()
      },
      searchProject () {
        const text = this.searchText

        // 보고서 프로젝트명 검색 클릭 시 API Parameter를 설정해준다.
        this.tableOptions.parameter[1].value = text
        this.$refs.grid.refresh()
      },
      playVideoOnBenefitSection () {
        // 지정된 영역에 스크롤이 있을 경우 비디오를 재생한다.
        // 지정된 영역을 벗어날 경우 비디오를 멈춘다.
        const benefit = document.querySelector('#benefit')
        const video = benefit.querySelector('.tab-pane.active video')
        const targetPositionY = benefit.offsetTop - 64
        const currentPositionY = window.scrollY
        const isPlayPosition = targetPositionY < currentPositionY

        if (video) {
          if (isPlayPosition && video.paused) {
            video.play()
          } else if (!isPlayPosition && !video.paused) {
            video.pause()
          }
        }
      }
    },
    created () {
      const token = localStorage.getItem('_t')

      // 토큰이 있을 경우, 토큰의 유호성을 검사한다.
      if (token) {
        this.$store.dispatch('inspectToken', token).then(() => {
          // 유효한 토큰 일 경우 보고서 이동, 삭제 이벤트를 등록해준다.
          this.$nextTick(() => {
            this.setDownloadEvent()
            this.setRemoveEvent()
          })
        })
      }
    },
    mounted () {
      // 로그인한 유저 일 경우, 해당 페이지에 접근권한이 있는지 확인한다.
      if (typeof this.user.id !== 'undefined') {
        this.$store.dispatch('checkAccessMenu')
      }

      // 영상 자동재생 이벤트 리스너
      window.addEventListener('scroll', this.playVideoOnBenefitSection)

      $('#benefit a[data-toggle="tab"]').on('shown.bs.tab', () => {
        const video = document.querySelector('#benefit .tab-pane.active video')
        if (video) {
          video.play()
        }
      })

      $('#benefit a[data-toggle="tab"]').on('hide.bs.tab', () => {
        const video = document.querySelector('#benefit .tab-pane.active video')
        if (video) {
          video.currentTime = 0
          video.pause()
        }
      })
    },
    beforeDestroy () {
      // 엘리먼트 및 이벤트 초기화
      kendo.destroy(document.body)
      window.removeEventListener('scroll', this.playVideoOnBenefitSection)
      $(document).off('click', '.kendo-grid tbody tr .glyphicon')
      $(document).off('click', '.kendo-grid tbody tr .k-grid-remove')
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/pages/index_report';
  @import '~@/assets/css/components/tab';

  #hero {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url("../../assets/img/premium/hero-premium-lg@2x.jpg");

    .container {
      padding: 95px 0 95px 96px;
    }

    h1 {
      color: $hzc-white;
    }

    p {
      margin: 0 0 24px;
      color: $orange;
    }

    @media (max-width: $screen-xs-max) {
      text-align: center;

      .container {
        padding: 84px 16px;
      }
    }
  }

  #benefit {
    .nav-tabs {
      max-width: 472px;
    }

    .video-border {
      position: absolute;
      top: 68px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% + 32px);
      height: calc(100% - 68px);

      @media (max-width: $screen-xs-max) {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/extend/Extend.vue